
const xss = require('xss')

const options = {
  css: false,
  onTag: function (tag, html, options) {
    if (tag === 'iframe') {
      return html.replace(/javascript:?/, '')
    }
  },
  // 防止把页面款式过滤掉
  onIgnoreTagAttr: function (tag, name, value, isWhiteAttr) {
    // 过滤掉标签上的事件
    if (/^[^on]/.test(name)) {
      return name + '="' + xss.escapeAttrValue(value) + '"'
    }
  },
}
const filter = new xss.FilterXSS(options)

export default filter


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/utils/xss.js
// module id = null
// module chunks = 